/**
 * File scroll-top.js.
 *
 * Handles toggling 'to top' button and scrolling to page top.
 */
import { _$ } from './utils'

document.addEventListener('DOMContentLoaded', () => {
  const scrollButton = _$('scroll-top')
  if (!scrollButton) return

  // scrolls to top
  scrollButton.addEventListener('click', (e) => {
    e.preventDefault()
    window.scrollBy(0, -window.scrollY)
  })

  // toggles 'to top' button
  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      scrollButton.classList.remove('hidden')
    } else {
      scrollButton.classList.add('hidden')
    }
  })
})
